// Player fire: a click picks the nearest armed base (by x) and launches an
// interceptor toward the crosshair. Center base (Bravo) fires faster.

import type { Base, PlayerMissile } from '../state/types';
import type { ApplyFire } from './contracts';
import { mapBases } from '../state/update';
import { direction, scale } from '../geometry/vec2';
import { FIELD_H, FIELD_W, INTERCEPTOR_SPEED } from '../constants';

const inField = (x: number, y: number): boolean =>
  x >= 0 && x <= FIELD_W && y >= 0 && y <= FIELD_H;

export const applyFire: ApplyFire = (state, input) => {
  if (state.phase.kind !== 'playing' || input.fire === null) return state;
  const target = input.fire.target;
  if (!inField(target.x, target.y)) return state; // ignore letterbox / off-field clicks

  let chosen: Base | null = null;
  let bestDx = Infinity;
  for (const b of state.bases) {
    if (!b.alive || b.ammo <= 0) continue;
    const dx = Math.abs(b.pos.x - target.x);
    if (dx < bestDx) {
      bestDx = dx;
      chosen = b;
    }
  }
  if (chosen === null) return state;

  const base = chosen;
  const vel = scale(direction(base.pos, target), INTERCEPTOR_SPEED[base.id]);
  const missile: PlayerMissile = {
    id: state.nextEntityId,
    baseId: base.id,
    origin: base.pos,
    pos: base.pos,
    target,
    vel,
    alive: true,
  };

  const bases = mapBases(state.bases, (b) =>
    b.id === base.id ? { ...b, ammo: b.ammo - 1 } : b,
  );

  return {
    ...state,
    bases,
    playerMissiles: [...state.playerMissiles, missile],
    nextEntityId: state.nextEntityId + 1,
  };
};
